import { render, staticRenderFns } from "./HotSeat.vue?vue&type=template&id=00559c43&scoped=true"
import script from "./HotSeat.vue?vue&type=script&lang=ts"
export * from "./HotSeat.vue?vue&type=script&lang=ts"
import style0 from "./HotSeat.vue?vue&type=style&index=0&id=00559c43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00559c43",
  null
  
)

export default component.exports